import { LeadExternalSystem } from "../Utils/Enums";
import IContactInfo from "../V2/Playbook/Search/Types/IContactInfo";
import { Customer } from "./Customer";
import { MarketingCampaign } from "./MarketingCampaign";
import { Opportunity } from "./Opportunity";

export class LeadResult {
  id?: string;
  appointmentId!: string | null;
  customerId!: string | null;
  disqualifyingReasons!: Record<string, boolean>;
  notOfferedProcedures!: Record<string, boolean>;
  notes!: string | null;
  opportunityId!: string | null;
  type!: number;
}

export enum LeadStatus {
  New = 1,
  AgentSent = 2,
  AgentPickedUp = 3,
  GuestsSent = 4,
  GuestsPickedUp = 5,
  NoBook = 6,
  Book = 7,
  OnRelease = 8
}

export class Lead implements IContactInfo {
  id: string;
  campaign: MarketingCampaign;
  centerId: string | null;
  customers: Customer[];
  email: string | null;
  externalSystem: LeadExternalSystem;
  externalSystemId: string | null;
  firstName: string | null;
  ivrContactId: number | null;
  lastName: string | null;
  outbound: {
    customer: Customer;
    opportunity: Opportunity;
  } | null;
  phoneNumber: string | null;
  userId: string | null;
  utmSource: string | null;
  utmCreative: string | null;
  result: LeadResult | null;
  status: LeadStatus;
  zipCode: string | null;

  constructor(lead?: Partial<Lead>) {
    this.id = lead?.id || "";
    this.campaign = new MarketingCampaign();
    this.centerId = null;
    this.customers = lead?.customers || [];
    this.email = null;
    this.externalSystem = lead?.externalSystem || LeadExternalSystem.FrontEnd;
    this.externalSystemId = lead?.externalSystemId || null;
    this.firstName = lead?.firstName || null;
    this.ivrContactId = lead?.ivrContactId || null;
    this.lastName = lead?.lastName || null;
    this.outbound = lead?.outbound || null;
    this.phoneNumber = lead?.phoneNumber || null;
    this.userId = lead?.userId || null;
    this.utmSource = lead?.utmSource || null;
    this.utmCreative = lead?.utmCreative || null;
    this.result = lead?.result || null;
    this.status = lead?.status || LeadStatus.New;
    this.zipCode = lead?.zipCode || null;
  }

  /** Determines whether the "direction" is outbound. This is includes actual outbounds made by the Dialer
   * and also chat and webform callbacks, which are "outbound" from the perspective of the PA/Patient.
   */
  static isOutboundDirection = (lead: Lead) => {
    return (
      lead.externalSystem === LeadExternalSystem.InContactChat ||
      lead.externalSystem === LeadExternalSystem.WebForm ||
      lead.externalSystem === LeadExternalSystem.OutboundDial
    );
  };
}
